
import BaseNewsTickerWidget from '../../../../base/components/sidebar/widgets/NewsTickerWidget.vue'

export default class NewsTickerWidget extends BaseNewsTickerWidget {}
